var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "9 11 11 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m12.646 18.858-3.5-3.417a.47.47 0 0 1 0-.683l.707-.684a.516.516 0 0 1 .707 0L13 16.467l5.44-5.325a.51.51 0 0 1 .706 0l.707.683a.47.47 0 0 1 0 .683l-6.5 6.35a.51.51 0 0 1-.707 0"
})));
export default SvgCheckmark;